export default __webpack_public_path__ + "static/media/Eloise.a3d394b5.gif";